module.exports = __webpack_public_path__ + "static/assets/dc97849515ceed1012a3b89210a950fa.png";